var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.89 1.45L20.89 5.45C21.2232 5.61558 21.5036 5.87083 21.6997 6.18705C21.8958 6.50327 21.9998 6.86792 22 7.24V16.77C21.9998 17.1421 21.8958 17.5067 21.6997 17.823C21.5036 18.1392 21.2232 18.3944 20.89 18.56L12.89 22.56C12.6121 22.699 12.3057 22.7714 11.995 22.7714C11.6843 22.7714 11.3779 22.699 11.1 22.56L3.1 18.56C2.76713 18.3923 2.48776 18.1349 2.29339 17.8168C2.09903 17.4988 1.99741 17.1327 2 16.76V7.24C2.0002 6.86792 2.10419 6.50327 2.30028 6.18705C2.49637 5.87083 2.77679 5.61558 3.11 5.45L11.11 1.45C11.3866 1.31258 11.6912 1.24106 12 1.24106C12.3088 1.24106 12.6134 1.31258 12.89 1.45V1.45Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32 6.16L12 11L21.68 6.16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.76V11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.ac1e9ff6.svg";
export { ForwardRef as ReactComponent };